import { Injectable, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService {
  private _toastr = inject(ToastrService);

  private errorMessages: Record<string, string> = {
    invalid_username_or_pwd: 'Invalid username or password.',
    invalid_temp_code: 'The temporary code is invalid or has expired.',
    temp_code_already_used: 'This temporary code has already been used.',
    identity_not_setup_for_otp:
      'Multi-factor authentication is not set up for this identity.',
    invalid_otp_provided:
      'The OTP provided is incorrect or expired. Please try again.',
  };

  handleError(errorCode: string): void {
    const message =
      this.errorMessages[errorCode] ||
      'An unexpected error occurred. Please try again later.';
    this._toastr.error(`${'Error: ' + message}`);
  }
}
